import { STORAGE_KEY } from '@/common/constants';
import type { ContainerData } from '@/common/types';

type StoragePayload = {
	i: boolean;
	c: number[][];
};
const values = ref<StoragePayload>();

export function useCalculatorStorage() {
	const route = useRoute();
	const router = useRouter();
	const storage = useLocalStorage();

	watchEffect(() => {
		storage.setItem(STORAGE_KEY.calculator, JSON.stringify(values.value));
	});

	function _parseValues(v?: string) {
		if (!v) return null;
		const payload = JSON.parse(v) as StoragePayload;

		return {
			isInsure: payload.i,
			items: payload.c.map(([w, h, l, we, count]) => {
				return {
					count,
					width: w,
					height: h,
					length: l,
					weight: we
				};
			})
		};
	}

	function getLocalValues() {
		try {
			const localValues = storage.getItem(STORAGE_KEY.calculator) ?? '';
			return _parseValues(localValues);
		} catch (e) {
			console.error(e);
			return null;
		}
	}

	function getRawValues() {
		try {
			return storage.getItem(STORAGE_KEY.calculator) ?? '';
		} catch (e) {
			console.error(e);
			return null;
		}
	}

	function getQueryValues() {
		try {
			const query = route.query as unknown as { values: string };
			return _parseValues(query.values);
		} catch (e) {
			console.error(e);
			return null;
		}
	}

	function getStorageValues() {
		const queryValues = getQueryValues();
		const localValues = getLocalValues();

		return queryValues ?? localValues;
	}

	function saveValues(isInsure: boolean, items: ContainerData[]) {
		const list = items
			.map((v) => [
				v.width ?? 0,
				v.height ?? 0,
				v.length ?? 0,
				v.weight ?? 0,
				v.count ?? 0
			])
			.filter((v) => v.some((i) => i > 0));

		if (!list.length) return;

		values.value = {
			i: isInsure,
			c: list
		};
	}

	async function resetQuery() {
		await router.replace({ query: {}, hash: route.hash });
	}

	return {
		values,
		saveValues,
		resetQuery,
		getRawValues,
		getLocalValues,
		getStorageValues
	};
}
